import { render, staticRenderFns } from "./buyereslips.vue?vue&type=template&id=6f57edf2"
import script from "./buyereslips.vue?vue&type=script&lang=js"
export * from "./buyereslips.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports